import { render, staticRenderFns } from "./Multimetr.vue?vue&type=template&id=4adafda2&"
import script from "./Multimetr.vue?vue&type=script&lang=js&"
export * from "./Multimetr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports